//--------------------------
// extract race/role labels
//--------------------------
export default function extractLabels(objArray) {
  let labels = objArray.map((a) => a.label);
  return labels;
}
